import {
  faCalendarAlt,
  faCheckCircle,
  faExclamationCircle,
  faPen,
  faPortrait,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import UncontrolledTooltip from 'reactstrap/lib/UncontrolledTooltip.js';
import tinycolor from 'tinycolor2';
import style from './style.js';

const CandidateDropDownItem = ({
  candidate,
  onEditCandidate,
  onCalendarClick,
  interviewLimit,
  scheduleData,
  allowInterviewLimit,
  scheduleID,
}) => {
  const { PhotoUrl, CandidateSubHeading, HasBeenSentSchedule, FirstName = '', LastName = '' } = candidate || {};
  const { headers } = scheduleData;

  // Helper function to count candidate's flex events (use backend count if available)
  const getCandidateFlexEventCount = (candidate, scheduleData) => {
    if (!candidate) {
      return 0;
    }

    // Use backend count if available (more accurate)
    if (candidate.CountOfFlexEvents !== undefined) {
      return candidate.CountOfFlexEvents || 0;
    }

    // Fallback to frontend calculation for backward compatibility
    if (!scheduleData || !scheduleData.metaData) {
      return 0;
    }

    const { FlexEvents = [] } = scheduleData.metaData;
    let flexEventCount = 0;

    FlexEvents.forEach((flexEvent) => {
      if (flexEvent.AttendingCandidates && flexEvent.AttendingCandidates.length > 0) {
        const candidateInFlexEvent = flexEvent.AttendingCandidates.find(
          (c) => c.pk_Candidate === candidate.pk_Candidate,
        );

        if (
          candidateInFlexEvent &&
          flexEvent.EventName !== 'UNAVAILABLE' &&
          flexEvent.FlexEventName !== 'UNAVAILABLE'
        ) {
          flexEventCount++;
        }
      }
    });

    return flexEventCount;
  };

  // Helper function to get actual interview count (backend provides separated counts)
  const getCandidateInterviewCount = (candidate, scheduleData) => {
    if (!candidate) {
      return 0;
    }

    // Backend already provides separated counts, no need to subtract
    return candidate.CountOfScheduleInterviews || 0;
  }; // Check if flex events exist in the data (regardless of column configuration)
  const hasFlexEventData = () => {
    if (!scheduleData || !scheduleData.metaData) {
      return false;
    }

    const hasFlexEvents = scheduleData.metaData.FlexEvents && scheduleData.metaData.FlexEvents.length > 0;
    return hasFlexEvents;
  };

  let candidateName = `---`;

  if (candidate) {
    candidateName = ` ${LastName ? `${LastName}, ` : ''} ${FirstName || ''}`;
  }

  const interviewCount = getCandidateInterviewCount(candidate, scheduleData);
  const flexEventCount = getCandidateFlexEventCount(candidate, scheduleData);
  const hasFlexData = hasFlexEventData();

  return (
    <div
      style={{
        ...style.itemRow,
        backgroundColor: candidate.color,
        color: tinycolor(candidate.color).isLight() ? 'black' : 'white',
      }}
    >
      <div style={style.simpleColumn}>
        <div style={style.simpleRow}>
          <div style={{ ...style.simpleColumn, justifyContent: 'center', alignItems: 'center' }}>
            {PhotoUrl ? (
              <img src={PhotoUrl} alt={candidateName} style={style.imgPlaceHolder} />
            ) : (
              <FontAwesomeIcon style={style.imgPlaceHolder} icon={faPortrait} />
            )}
          </div>

          <div style={style.candidateInfo}>
            <div>{candidateName}</div>
            <div style={{ fontSize: 11, fontWeight: 'normal' }}>
              Interviews: {interviewCount} / {allowInterviewLimit ? interviewLimit : headers.length}
            </div>
            {hasFlexData && <div style={{ fontSize: 11, fontWeight: 'normal' }}>Flex Events: {flexEventCount}</div>}
            <div style={{ fontSize: 11, fontWeight: 'normal' }}>
              {CandidateSubHeading ? CandidateSubHeading : '---'}
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <FontAwesomeIcon
            style={style.buttonIcon}
            icon={faPen}
            onClick={() => {
              const pk_Department =
                sessionStorage.getItem('department') ||
                candidate.fk_Department ||
                (scheduleData && scheduleData.metaData && scheduleData.metaData.pk_Department);
              const departmentQuery = pk_Department ? `&pk_Department=${pk_Department}` : '';
              window.open(
                `/administrator/candidates?pk_Candidate=${candidate.pk_Candidate}${departmentQuery}`,
                '_blank',
                'noopener,noreferrer',
              );
              // For Candidate AND Date. Doesn't work. Very sad. Could be date listener conflciting with candidate listener.
              // window.open(
              //   `/administrator/candidates?pk_Candidate=${candidate.pk_Candidate}&pk_InterviewDate=${scheduleID}`,
              //   '_blank',
              // );
            }}
          />
        </div>
        <div>
          <FontAwesomeIcon
            style={{ ...style.buttonIcon, cursor: candidate.ScheduleUUID ? 'pointer' : 'not-allowed' }}
            icon={faCalendarAlt}
            onClick={() => {
              if (candidate.ScheduleUUID != null) {
                // history.push(`/candidate/schedule/${candidate.ScheduleUUID}`);
                window.open(
                  `/candidate/schedule/${candidate.ScheduleUUID}?preview=true`,
                  '_blank',
                  'noopener,noreferrer',
                );
              }
            }}
          />
        </div>
        <div>
          <FontAwesomeIcon
            id={`candidate_status_${candidate.pk_Candidate}`}
            style={{
              ...style.buttonIcon,
              color: HasBeenSentSchedule ? '#a1e3a5' : 'red',
              border: '2px solid',
              borderColor: tinycolor(candidate.color).isLight() ? 'black' : 'white',
              borderRadius: 20,
              backgroundColor: tinycolor(candidate.color).isLight() ? 'black' : 'white',
            }}
            icon={HasBeenSentSchedule ? faCheckCircle : faExclamationCircle}
          />
          <UncontrolledTooltip target={`candidate_status_${candidate.pk_Candidate}`}>
            {HasBeenSentSchedule ? 'Candidate has been sent schedule!' : 'Candidate has not been sent schedule!'}
          </UncontrolledTooltip>
        </div>
      </div>
    </div>
  );
};

export default CandidateDropDownItem;
